export default __webpack_public_path__ + "static/media/sign up farmer2.e7cc0f4a.png";